<template>
  <div class="product-widget mb-30">
    <h5 class="pt-title">Categories</h5>
    <div class="widget-category-list mt-20">
      <div 
        class="single-widget-category pointer" 
        v-for="c in categoryData" 
        :key="c.id" 
      >
        <input 
          type="checkbox" 
          :id="`cat-item-${c.id}`" 
          :checked="String(activeQuery) === String(c.id)" 
          :class="{ checked: activeQuery == c.id }"
        >
        <label 
          @click="handleCategoryRoute(c.id)" 
          :for="`cat-item-${c.id}`" 
          class="pointer"
        >
          {{ c.name }} <span></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCategories",
  data() {
    return {
      categoryData: [], // Initialize as an empty array
      activeQuery: "",
    };
  },
  watch: {
    "$route.query": {
      handler(newQuery) {
        this.activeQuery = newQuery.web_category || '';
        console.log('Active Query:', this.activeQuery);
      },
      immediate: true,
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await this.$axios.get('/website-categories');
        this.categoryData = response.data
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    handleCategoryRoute(value) {
      this.$router.push({ 
        path: '/shop', 
        query: { web_category: value } 
      });
    },
  },
  mounted() {
    this.activeQuery = this.$route.query.web_category;
    console.log('Active Query:', this.activeQuery);
    this.fetchCategories(); // Fetch categories when the component is mounted
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.single-widget-category label::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900; /* Ensures solid icon */
}
</style>
